export default {
  cities: [],
  clients: [],
  statistics: [],
  manufactures: [],
  families: [],
  lastUpdate: {},
  clientCityFilter: {},
};
